import React from "react";
import { WORKFLOW_STATUS } from "common/constants";
import { Tag, TagProps } from "../Common/Tag";

type WorkflowStatus = (typeof WORKFLOW_STATUS)[keyof typeof WORKFLOW_STATUS];

const workflowStatusToStyleVariant: Record<
  WorkflowStatus,
  TagProps["styleVariant"]
> = {
  [WORKFLOW_STATUS.NOT_STARTED]: "neutral",
  [WORKFLOW_STATUS.IN_PROGRESS]: "warning",
  [WORKFLOW_STATUS.LOCKED]: "neutral",
  [WORKFLOW_STATUS.OPEN]: "warning",
  [WORKFLOW_STATUS.COMPLETE]: "default",
  [WORKFLOW_STATUS.REJECTED]: "critical",
};

type Props = {
  status: WorkflowStatus;
} & Omit<TagProps, "styleVariant">;

export function WorkflowStatusTag({ status, ...props }: Props) {
  const styleVariant = workflowStatusToStyleVariant[status];

  return (
    <Tag {...props} styleVariant={styleVariant}>
      {status}
    </Tag>
  );
}
